import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  changeUserPassword,
  sendPasswordConfirmation,
} from "../../api";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import { FaTimes } from "react-icons/fa";
import logo from "../../Resources/Transparent_Logo.png";
import Spinner from "react-bootstrap/Spinner";

export default function PasswordReset() {
  const [errorAlert, setErrorAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    password1: "",
    password2: "",
  });

  const { id, encodedEmail } = useParams();
  const email = decodeURIComponent(encodedEmail);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrorAlert(false);
    setSuccessAlert(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorAlert(false);
    setSuccessAlert(false);

    if (data.password1 !== data.password2) {
      setErrorAlert(true);
      return;
    }

    try {
      setLoading(true);
      const response = await changeUserPassword(id, data.password1);
      if (response.status === 200) {
        await sendPasswordConfirmation(email);
        setSuccessAlert(true);
        setTimeout(() => navigate("/login"), 1000);
      } else {
        setErrorAlert(true);
      }
    } catch (error) {
      setErrorAlert(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClose = () => {
    setErrorAlert(false);
    setSuccessAlert(false);
    setData({
      userEmail: "",
      password1: "",
      password2: "",
    });
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100">
      <div className="container shadow-sm p-4 bg-white rounded" style={{ maxWidth: "50%" }}>
        <div className="text-center">
          <img src={logo} alt="Logo" style={{ width: "100px", height: "80px" }} />
          <h4 className="mt-3 text-primary">Change Password</h4>
          <p className="fw-light fs-sm">Please complete the fields below to change your password.</p>
        </div>

        {errorAlert && (
          <Alert variant="danger" className="d-flex align-items-center justify-content-between">
            <span>Your passwords don't match.</span>
            <Button className="text-black bg-transparent border-0 fs-6" onClick={handleCancelClose}>
              <FaTimes />
            </Button>
          </Alert>
        )}
        {successAlert && (
          <Alert variant="success" className="d-flex align-items-center justify-content-between">
            <span>Your password was updated successfully</span>
            <Button className="text-black bg-transparent border-0 fs-6" onClick={handleCancelClose}>
              <FaTimes />
            </Button>
          </Alert>
        )}

        <Form onSubmit={handleSubmit} className="mt-3">
          <Row className="mb-3">
            <Col>
              <Form.Group controlId="password1">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  required
                  type="password"
                  name="password1"
                  value={data.password1}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Group controlId="password2">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  required
                  type="password"
                  name="password2"
                  value={data.password2}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col className="d-flex justify-content-center">
              <Button variant="primary" type="submit" className="w-50" disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" role="status" /> : "Submit"}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
}
